<style lang="scss" scoped>
.box {
  border: 1px solid #e6ddd2;
  margin: 25px;
  text-align: center;
  padding: 50px 15px;
  transition: all 200ms ease;
  @media (max-width: 1200px) {
    margin: 0;
    margin-bottom: 30px;
  }
  .name {
    font-weight: 700;
  }
  .ort {
    margin: 10px 0;
    &:before {
      content: '';
      display: none;
      width: 70px;
      margin: 5px auto;
      height: 3px;
      background: $c-dark-blue;
    }
  }
  .url {
    a {
      display: block;
      text-decoration: none;
      color: $c-dark-blue;
    }
  }
  &:hover {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  }
}

.modal-btn {
  //border:1px solid blue;
  padding: 5px 10px 5px 10px;
  margin-top: 15px;
  &:before {
    content: '';
    display: block;
    width: 100px;
    margin: 5px auto;
    height: 3px;
    background: $c-dark-blue;
  }
  span {
    font-size: 14px;
    display: inline-block;
    margin-left: 5px;
    margin-right: 3px;
    position: relative;
    top: 0px;
  }
  svg {
    fill: $c-mediumdark-gray;
    width: 20px;

    height: 20px;
  }
}

.inner-modal {
  .row {
    //border:1px solid red;
    padding-top: 7px;
    padding-bottom: 7px;
    margin-bottom: 10px;
    &:nth-child(even) {
      background: $c-medium-gray;
    }
    .label {
      text-align: right;
      font-weight: 500;
      @media (max-width: 992px) {
        text-align: left;
      }
    }
  }
}
</style>

<template>
  <div class="col-lg-4 col-md-6">
    <!-- VIEW -->
    <div class="box" v-if="!edit">
      <div class="name">{{ name }}</div>
      <div class="ort">{{ ort }}</div>
      <div class="url">
        <a :href="url">{{ url }}</a>
      </div>
      <ModalButton :link="`modal-${id}`" class="modal-btn">
        <span>Mehr Infos</span><Icon :path="mdiChevronRight" :height="30" :width="30"
      /></ModalButton>
    </div>
    <!-- EDIT -->
    <div class="box" v-if="edit">
      <div><LabeledInput label="Name" v-model="name" /></div>
      <div><LabeledInput label="Ort" v-model="ort" /></div>
      <div><LabeledInput label="Schwerpunkt" v-model="schwerpunkt" /></div>
      <div><LabeledInput label="Referenz" v-model="referenz" /></div>
      <div><LabeledInput label="Feedback" v-model="feedback" /></div>
      <div><LabeledInput label="Tagsatz" v-model="tagsatz" /></div>
      <div><LabeledInput label="Tagsatz-Kommentar" v-model="tagsatzcomment" /></div>
      <div><LabeledInput label="Url" v-model="url" /></div>

      <div class="mt-4"><button @click="save">Speichern</button></div>
      <div class="mt-2"><button @click="del">Löschen</button></div>
    </div>
    <Modal :link="`modal-${id}`" :title="name">
      <div class="inner-modal">
        <div class="row">
          <div class="col-lg-3 label">Name</div>
          <div class="col-lg-9">{{ name }}</div>
        </div>
        <div class="row">
          <div class="col-lg-3 label">Schwerpunkte</div>
          <div class="col-lg-9">{{ schwerpunkt }}</div>
        </div>
        <div class="row">
          <div class="col-lg-3 label">Referenzkontakt</div>
          <div class="col-lg-9">{{ referenz }}</div>
        </div>
        <div class="row">
          <div class="col-lg-3 label">Feedback</div>
          <div class="col-lg-9">{{ feedback }}</div>
        </div>
        <div class="row">
          <div class="col-lg-3 label">Tagsatz STYRIA</div>
          <div class="col-lg-9">{{ tagsatz }}</div>
        </div>
        <div class="row">
          <div class="col-lg-3 label">Anmerkungen Tagsatz</div>
          <div class="col-lg-9">{{ tagsatzcomment }}</div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType, ref } from 'vue';
import ModalButton from '@/components/util/ModalButton.vue';
import Modal from '@/components/util/Modal.vue';
import { mdiChevronRight } from '@mdi/js';
import { useStore } from 'vuex';

type TrainerRecord = {
  id: number;
  name: string;
  ort: string;
  schwerpunkt: string;
  referenz: string;
  feedback: string;
  tagsatz: string;
  tagsatzcomment: string;
  url: string;
};

export default defineComponent({
  components: {
    ModalButton,
    Modal,
  },
  emits: ['changed'],
  props: {
    trainer: { type: Object as PropType<TrainerRecord>, required: true },
    edit: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    //const edit = ref(false);
    const store = useStore();
    const id = ref(0);
    const name = ref('');
    const ort = ref('');
    const schwerpunkt = ref('');
    const referenz = ref('');
    const feedback = ref('');
    const tagsatz = ref('');
    const tagsatzcomment = ref('');
    const url = ref('');

    onMounted(() => {
      if (props.trainer.id != 0) {
        id.value = props.trainer.id;
        name.value = props.trainer.name;
        ort.value = props.trainer.ort;
        schwerpunkt.value = props.trainer.schwerpunkt;
        referenz.value = props.trainer.referenz;
        feedback.value = props.trainer.feedback;
        tagsatz.value = props.trainer.tagsatz;
        tagsatzcomment.value = props.trainer.tagsatzcomment;
        url.value = props.trainer.url;
      }
    });

    const save = () => {
      const data = {
        name: name.value,
        ort: ort.value,
        schwerpunkt: schwerpunkt.value,
        referenz: referenz.value,
        feedback: feedback.value,
        tagsatz: tagsatz.value,
        tagsatzcomment: tagsatzcomment.value,
        url: url.value,
      };
      if (id.value != 0) {
        store.dispatch('updateTrainer', { id: id.value, data }).then(() => {
          emit('changed');
        });
      } else {
        store.dispatch('addtrainer', data).then(() => {
          emit('changed');
        });
      }
      // edit.value = false;
    };

    const del = () => {
      store.dispatch('deleteTrainer', id.value).then(() => {
        emit('changed');
      });
    };

    // const onEdit = () => {
    //   edit.value = true;
    // };

    //     fetchTrainers(context: any) {

    // deleteTrainer(context: any, id: number) {

    // updateTrainer(context: any, payload: { id: number; data: TrainerRequestBody }) {

    // addtrainer(context: any, payload: TrainerRequestBody) {

    return {
      mdiChevronRight,
      save,
      del,
      //   onEdit,
      id,
      name,
      ort,
      schwerpunkt,
      referenz,
      feedback,
      tagsatz,
      tagsatzcomment,
      url,
      // edit,
    };
  },
});
</script>
